import { Command } from 'commander'

export const preview = new Command().name('preview').description('Hashnode docs preview')
